import './styles.css';

export default function Loader(props) {
    return (
        <div className='loader'>
            <div className='overlay'></div>
            <div className='absolute text-center'>
                <div className='lds-roller'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    );
}